import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import context from "../scripts/context";

function Protected ({isLoggedIn, children}) {
    const [userInfo, setUserInfo] = useState(context.getUserInfo())

    useEffect(() => {
        context.addListenerUserInfo(setUserInfo)
        return () => context.removeListenerUserInfo(setUserInfo)
    }, [])

    console.log('hooosh', isLoggedIn)
    if(!isLoggedIn) {
        return <Navigate to={'/agent/login'}/>
    }
    if(!userInfo) return null
    return children
}

export default Protected
